var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "fish-history-content" }, [
      _c(
        "div",
        { staticClass: "fish-history-header" },
        [
          _c(
            "router-link",
            { staticClass: "back-link", attrs: { to: "/mypage" } },
            [
              _c(_setup.ChevronLeftIcon, {
                attrs: { size: 16, fillColor: "#67A9E7" },
              }),
              _vm._v(" " + _vm._s(_setup.t("fishHistory.backToMyPage")) + " "),
            ],
            1
          ),
          _c("div", { staticClass: "fish-history-header-title" }, [
            _vm._v(_vm._s(_setup.t("fishHistory.title"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fish-history-list" },
        [
          _vm._l(_setup.paginatedItemsWithExpiration, function (item) {
            return _c(
              "div",
              { key: item.transactionId, staticClass: "history-item" },
              [
                _c("div", { staticClass: "history-item-header" }, [
                  _c("div", { staticClass: "header-label" }, [
                    _vm._v(_vm._s(_setup.t("fishHistory.total"))),
                  ]),
                  _c("div", { staticClass: "header-date" }, [
                    _vm._v(_vm._s(_setup.formatCreatedAt(item.createdAt))),
                  ]),
                ]),
                _c("div", { staticClass: "history-item-main" }, [
                  _c("div", { staticClass: "amount-section" }, [
                    _c(
                      "div",
                      {
                        staticClass: "amount-value",
                        class: { negative: item.isNegative },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_setup.formatNumber(item.amount)) +
                            " fish "
                        ),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "type-section" }, [
                    _c("div", { staticClass: "transaction-type" }, [
                      _vm._v(_vm._s(item.transactionTypeLabel)),
                    ]),
                  ]),
                ]),
                _setup.shouldShowBreakdown(item)
                  ? _c("div", { staticClass: "breakdown-section" }, [
                      _c("div", { staticClass: "breakdown-label" }, [
                        _vm._v(_vm._s(_setup.t("fishHistory.breakdown"))),
                      ]),
                      _c(
                        "div",
                        { staticClass: "breakdown-items" },
                        _vm._l(
                          _setup.getBreakdownEntries(item),
                          function (entry, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "breakdown-item" },
                              [
                                _c("div", { staticClass: "breakdown-source" }, [
                                  _c("span", { staticClass: "source-label" }, [
                                    _vm._v(_vm._s(entry.label)),
                                  ]),
                                  _c("span", { staticClass: "source-amount" }, [
                                    _vm._v(
                                      _vm._s(
                                        entry.amount.toLocaleString("ja-JP")
                                      )
                                    ),
                                  ]),
                                  !item.isNegative &&
                                  _setup.shouldShowExpiration(entry.expiredAt)
                                    ? _c("span", [
                                        _c(
                                          "span",
                                          { staticClass: "expiration-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _setup.t(
                                                  "fishHistory.expirationLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _setup.formatExpiredAt(
                                                entry.expiredAt
                                              )
                                            ) +
                                            " "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          _setup.isLoading
            ? _c(_setup.LoadingSpinner, {
                attrs: {
                  text: _setup.t("fishHistory.loadingText"),
                  size: "medium",
                  variant: "inline",
                },
              })
            : _setup.error
            ? _c("div", { staticClass: "error-state" }, [
                _c("p", { staticClass: "error-message" }, [
                  _vm._v(_vm._s(_setup.error)),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "retry-button",
                    on: { click: _setup.retryLoadData },
                  },
                  [_vm._v(_vm._s(_setup.t("fishHistory.retryButton")))]
                ),
              ])
            : _setup.historyItems.length === 0
            ? _c("div", { staticClass: "no-data" }, [
                _c("p", [_vm._v(_vm._s(_setup.t("fishHistory.noData")))]),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "fish-history-footer" }, [
        _c("div", { staticClass: "pagination" }, [
          _c(
            "div",
            { staticClass: "pagination-pages" },
            _vm._l(_setup.visiblePages, function (page) {
              return _c(
                "button",
                {
                  key: page,
                  staticClass: "pagination-page",
                  class: {
                    active: page === _setup.currentPage,
                    "pagination-dots": page === "...",
                  },
                  attrs: { disabled: page === "..." },
                  on: {
                    click: function ($event) {
                      typeof page === "number" ? _setup.goToPage(page) : null
                    },
                  },
                },
                [_vm._v(" " + _vm._s(page) + " ")]
              )
            }),
            0
          ),
        ]),
        _setup.batchError
          ? _c(
              "div",
              { staticClass: "batch-error-state" },
              [
                _c("p", { staticClass: "batch-error-message" }, [
                  _vm._v(_vm._s(_setup.batchError)),
                ]),
                _setup.isLoadingBatch
                  ? _c(_setup.LoadingSpinner, {
                      attrs: {
                        text: _setup.t("fishHistory.loadingText"),
                        size: "small",
                        variant: "inline",
                      },
                    })
                  : _c(
                      "button",
                      {
                        staticClass: "batch-retry-button",
                        on: { click: _setup.retryLoadBatch },
                      },
                      [_vm._v(_vm._s(_setup.t("fishHistory.retryButton")))]
                    ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }